export const load = () => ({
	title: 'Bigfoot blocks cold drafts and noisy neighbors with inserts',
	h1: 'Big Problems Require Smart Solutions',
	description:
		'Learn how our famous furry friend made his new home more comfortable, quiet, and energy efficient with Indow window inserts.',
	showTitle: false,
});
